module.exports = __webpack_public_path__ + "static/media/eumodicogryllus_bordigalensis_022_APA.33793978.png";